$(function () {
      $("#loader-gif").fadeIn(200);
  	var size_from = $('#carat-size-range-min').val();
  	$('#size_from').val(size_from);
  
  	var size_to = $('#carat-size-range-max').val();
  	$('#size_to').val(size_to);
  	
	//az91o7ypp9eh  - ATLAS SETTING
  //  6jkzm4df8qb7 - LYNX SETTING
	var ring_setting =  localStorage.getItem('setting-id');
	
	if(ring_setting == 'az91o7ypp9eh'){ // IF ATLAS, ONLY SHOW Salt Pepper
		$('#product_type').val('b6kqfsn0927s');
		runSearch('b6kqfsn0927s');
		$('#salt-pepper-diamonds').css('display','none');
		$('#gemstone').css('display','none');
		$('#moissanite').css('display','none');
		$('#clear-diamond').css('display','none');
		$('#atlas-salt-pepper-diamonds').css('display','block').addClass('active');
	}else if(ring_setting == '6jkzm4df8qb7'){ // IF LYNX, ONLY SHOW Lynx Diamonds and Lynx Moisannite (6vfvfnx1jaq3)
		$('#product_type').val('6vfvfnx1jaq3');
		runSearch('6vfvfnx1jaq3');
		$('#salt-pepper-diamonds').css('display','none');
		$('#gemstone').css('display','none');
		$('#moissanite').css('display','none');
		$('#clear-diamond').css('display','none');
		$('#lynx-diamonds').css('display','block').addClass('active');
		$('#lynx-moissanite').css('display','block');
      
    }else{
		$('#product_type').val('pd7454oxzmg9');
		runSearch('pd7454oxzmg9');
	}
  	
  	
  
	// capture stone choice click - aka, product type.
    $(".stone-choice").on('click',function(){
      $("#loader-gif").fadeIn(200);
	  $("#filter-button").css('display','block');  
	  $('.carat-size-filter').css('display','block');
	  $("#shapeFilter").css('display','block');  
	  
	  $(".gemstone-type").removeAttr("checked");
	  $(".shape-choice").data('selected','0');
      $(".stone-choice").removeClass('active');
      $("#shape-choice").css('border','0px');
      
      $("#shape").val('');
      $("#gemstone_types").val('');
      
      
      
      $(this).addClass('active');
      
      var uid = $(this).data('uid');
      $('#product_type').val(uid);
      
        // get the options for this stone choice.
        $.get( "https://jewelety.com/api/v1/product-type/" + uid + "?public_token=f3CejjPx6YgwAX4YV8Vq7sGShBbZCwn43yJdah4P")
              .done(function( data ) {
          
                // loop over results for options, enable shapes for this stone type.
                $.each(data.options, function(i, item) {
                    //alert(item.field_label);

					// if it has a stone shape option, go grab the actual shapes available.
                    if(item.field_label == 'Stone Shape'){
                      
                      // hide all the shape options so we can turn on the proper ones.
                      $('.shape-choice').css('display','none');

                      $.get( "https://jewelety.com/api/v1/product-options/" + item.uid + "?public_token=f3CejjPx6YgwAX4YV8Vq7sGShBbZCwn43yJdah4P")
                            .done(function( data ) {

                            $.each(data.values, function(i, item) {
                              
                                // display the shapes available for this stone type and set the UID.
								$('.' + item.option_value).css('display','block').data('uid',item.uid);

                            });

                      });


                    }


                });

        });
        
        runSearch(uid);
        
 	  //show / hide gemstores container depending on product type selection.
      if($(this).data('gemstones') == 1){       
        $("#gemstone-filter-container").css("display", "block");
      }else{
	   
       $("#gemstone-filter-container").css("display", "none");
      }
    
    });  
    
    
      $('.stone-container').on('click','.card-img', function(){

         
	      
         if(localStorage.getItem('setting-id') == "brfpr5x7rzxn"){
             
             if(velaStoneChecker == 0){
	            window.scrollTo({ top: 0, behavior: 'smooth' }); 
              $("#vela-modal-background").css("display", "block");
                 $("#vela-modal-description").html("You have just chose your <strong> left stone </strong>. Please choose your right stone")

                 localStorage.removeItem('stone-1');
                 localStorage.removeItem('stone-one-dimm') 
                 localStorage.removeItem('stone-one-carat')
                 localStorage.removeItem("stone-one-price")


               
				 $(this).css('border', '3px solid #64513F');
                 
                 localStorage.setItem("stone-1",$(this).data('uid'));
                 localStorage.setItem('stone-one-dimm',$(this).data('dimensions'));
                 localStorage.setItem('stone-one-carat',$(this).data('caratweight'));
                 localStorage.setItem('stone-one-price',$(this).data('price'));

             }
                    
                if(velaStoneChecker == 1 ){
                       $("#vela-modal-background").css("display", "block");
                      $("#vela-modal-description").html("You have just chose your <strong> right stone </strong>. Please contineu to choose your ring box")

                    localStorage.removeItem('stone-2');
                    localStorage.removeItem('stone-two-dimm');
                    localStorage.removeItem('stone-two-carat');
                    localStorage.removeItem("stone-two-price");


                   $(this).css('border', '3px solid #64513F');
                	 localStorage.setItem("stone-2",$(this).data('uid'));
                      localStorage.setItem('stone-two-dimm',$(this).data('dimensions'));
                      localStorage.setItem('stone-two-carat',$(this).data('caratweight'));
                      localStorage.setItem('stone-two-price',$(this).data('price'));


                	 velaStoneChecker += 1;
                }
             
             	if(velaStoneChecker == 2){
                 location.href = "/pages/ring-box"
                 velaStoneChecker = 0
             	}
               velaStoneChecker++;

         
         }else{

           
			localStorage.removeItem('stone');
			localStorage.removeItem('stone-dimm');
			localStorage.removeItem('stone-carat');
			localStorage.removeItem('stone-price');
			
			localStorage.setItem("stone",$(this).data('uid'));
			localStorage.setItem("stone-dimm",$(this).data('dimensions'));
			localStorage.setItem("stone-carat",$(this).data('caratweight'));
			localStorage.setItem("stone-price",$(this).data('price'));
           
			//location.href = "/pages/ring-box";

        };
	   

  
    
     });
  
	
    // capture shape click.
    $(".shape-choice").on('click',function(){
      const selected_shapes = [];
      $("#loader-gif").fadeIn(200);
      // check to see if this shape is already selected. If not, adjust selected attribute.
      if($(this).data('selected') == '1') {
        $(this).data('selected','0');
      }else{        
        $(this).data('selected','1');
      }
      
      // Rebuild the selected_shapes array.
      $('.shape-choice').filter(function() {
        
        var this_uid = $(this).data('uid');
        var selected = $(this).data('selected');
         //$("#shape-icons div li img").removeAttr('style');
        // if selected, add it to the array.
        if(selected == '1'){
	      $(this).css('border','1px solid #64513F');
          //$("#shape-icons div li img").removeAttr('style');
          selected_shapes.push($(this).data('value'));
          
        }else{
          $(this).css('border','0px');
          // filter the array and remove any option that might still have a selected attribute. Probably not needed but whatevs.
          var filtered = selected_shapes.filter(function(value, index, arr){ 
              return value !== this_uid;
          });
          
        }
      });
      
      //alert(JSON.stringify(selected_shapes));
      $('#shape').val(selected_shapes);
      runSearch($('#product_type').val());
    
    });  
    
    // capture shape click.
    $(".gemstone-type").on('click',function(){
      $("#loader-gif").fadeIn(200);
      const selected_gemstones = [];
      
      // check to see if this shape is already selected. If not, adjust selected attribute.
      if($(this).is(":checked")) {
        $(this).data('selected','0');
      }else{        
        $(this).data('selected','1');
      }
      
      // Rebuild the selected_shapes array.
      $('.gemstone-type').filter(function() {
        
        var checked = $(this).is(":checked");
        
        // if selected, add it to the array.
        if(checked){
          
          selected_gemstones.push($(this).data('value'));
          
        }
        
      });
      
      //alert(JSON.stringify(selected_shapes));
      $('#gemstone_types').val(selected_gemstones);
      runSearch($('#product_type').val());
     
    
    });    
  
  	let ranges = document.querySelectorAll("#carat-ranges input")
    let carat_sizes = document.querySelectorAll("#carat-size-labels input")
    let progress = document.querySelector("#progress #slider")
    let gap = 0.5


    // let ctInput = document.querySelectorAll("#carat-size input")    

    carat_sizes.forEach( input  =>{
      input.addEventListener("change", e => {
      $("#loader-gif").fadeIn(200);
        let min = parseFloat(carat_sizes[0].value);
        let max = parseFloat(carat_sizes[1].value);
        
        $('#size_from').val(min);
        $('#size_to').val(max);
        
        runSearch($('#product_type').val());
 

    //    progress.style.left = (min / ranges[0].max) * 100 + "%"
    //    progress.style.right = 100 - (max / ranges[1].max) * 100 + "%"

       if((max - min  >= gap)  && max <= ranges[1].max ){
         if(e.target.id === "carat-size-range-min"){
            ranges[0].value = min;
             progress.style.left = ((min / ranges[0].max) * 100.0) + "%";
         }
         else{
            ranges[1].value = max;
             progress.style.right = ((max / ranges[1].max) * 100.0) + "%";
          }
       }

       })

    })
    
    ranges.forEach(input =>{
        input.addEventListener("change", e =>{
			$("#loader-gif").fadeIn(200);
            let minVal = parseFloat(ranges[0].value),
            maxVal = parseFloat(ranges[1].value);

          
          $('#size_to').val(maxVal);
          
            if((maxVal - minVal) < gap){
                if(e.target.id === "carat-size-range-min"){
                    ranges[0].value = maxVal - gap;
                  $('#size_from').val(maxVal - gap);
                  runSearch($('#product_type').val());

                }else{
                    ranges[1].value = minVal + gap;
                  $('#size_to').val(minVal + gap);
                     runSearch($('#product_type').val());

                }
            } else{
                carat_sizes[0].value = minVal;
                $('#size_from').val(minVal);
                carat_sizes[1].value = maxVal;
                $('#size_to').val(maxVal);
                progress.style.left = parseFloat(((minVal / ranges[0].max) * 100)) + "%";
                progress.style.right = 100 - parseFloat((maxVal / ranges[1].max) * 100) + "%";
                runSearch($('#product_type').val());

            }
        });
    });
  

	
	$('#filter-button').on('click',function(){
      $("#loader-gif").fadeIn(200);
      var product_type = null;
      var size_from = $('#carat-size-range-min').val();
      var size_to = $('#carat-size-range-max').val();
      var shape = null;
      var gemstone = null;
      
      runSearch($('#product_type').val());

		
	});
	
	function buildPages(count,page){
		
	    $('#pagination').html('');
	    
		  var lastViewablePage = parseInt(page) + 9;
		  var previousPage = parseInt(page) - 1;
		  var nextPage = parseInt(page) + 1;
		  var selectedPage = parseInt(page);
		  var paginationHtml = '';
	      var i;
	      var startingPosition = 1;
	      var pages = Math.ceil(count / 36);
	      
	      if(page <= 5){
		      startingPosition = 1;
		      lastViewablePage = 10;
	      }else{
		      startingPosition = page - 4;
		      lastViewablePage = parseInt(page) + 4;
	      }
	      
	      
	      
	      $('.search-order').attr('data-page',page);
	      		      		      
	      if(page > 5){
		      paginationHtml += '<a id="btn-previous" class="products-pagination" data-page="' + previousPage + '" style="text-decoration:none;margin:2px;">';
		      paginationHtml += '<button class="c-button c-button--tertiary" style="min-width:20px;margin-right:12px;background-color:#15262E;padding:12px 12px; ">';
			      paginationHtml += '<span style="font-weight:bold;font-size:26px;"> < </span>';
			  paginationHtml += '</button>';
		      paginationHtml += '</a>';
		      paginationHtml += '<a id="btn-first-viewable" class="products-pagination"  data-page="1" style="text-decoration:none;margin:2px;">';
		      paginationHtml += '<button class="c-button c-button--tertiary" style="min-width:20px;padding:12px 12px;">';
			      paginationHtml += '<span>1</span>';
			  paginationHtml += '</button>';
		      paginationHtml += '</a>';
		      paginationHtml += ' . ';
	      }
	      
	      var id_counter = 1;
	      for (i = startingPosition; i <= pages; i++){
		      paginationHtml += '<a id="btn-id-'+ id_counter +'" class="products-pagination" data-page="' + i + '" style="text-decoration:none;margin:2px;">';
		      paginationHtml += '<button class="c-button c-button--tertiary" style="min-width:20px;padding:12px 12px;';
		      
		      if(selectedPage == i){
			   paginationHtml += ' background-color:#4d6065;">'; 
			  }else{
			    paginationHtml += '">'; 
			  }
			  
		      if(selectedPage == i){
			   paginationHtml += '<span style="text-decoration:underline;">' + i + '</span>'; 
			  }else{
			    paginationHtml += '<span>' + i + '</span>'; 
			  }		
			    
			  paginationHtml += '</button>';
		      paginationHtml += '</a>';
		      
		      if(i == lastViewablePage){
		      
			      if(lastViewablePage != pages){
			      paginationHtml += ' . ';       
			      paginationHtml += '<a id="btn-last-viewable" class="products-pagination" data-page="' + pages + '" style="text-decoration:none;margin:2px;">';
			      paginationHtml += '<button class="c-button c-button--tertiary" style="min-width:20px;padding:12px 12px;">';
				      paginationHtml += '<span>' + pages + '</span>';
				  paginationHtml += '</button>';
			      paginationHtml += '</a>';
			      }
		      
				  break;
		      }
		      id_counter++;
		  }
		  
		  if(selectedPage != pages){
		      paginationHtml += '<a id="btn-next" class="products-pagination" data-page="' + nextPage + '" style="text-decoration:none;margin:2px;">';
		      paginationHtml += '<button class="c-button c-button--tertiary" style="min-width:20px;margin-left:12px;background-color:#15262E;padding:12px 12px;">';
			      paginationHtml += '<span style="font-weight:bold;font-size:26px;"> > </span>';
			  paginationHtml += '</button>';
		      paginationHtml += '</a>';
	      }
			    
	    $('#pagination').append(paginationHtml);	  
		
	}
	
	function runSearch(uid) {
		
		console.log('running search: ' + uid);
 
		$.ajax({
		    url: 'https://jewelety.com/api/v1/products/search',
		    dataType: 'json',
		    type: 'post',
		    contentType: 'application/json',
		    data: JSON.stringify( {"public_token": "f3CejjPx6YgwAX4YV8Vq7sGShBbZCwn43yJdah4P","page": 1, "take":1000,"type_uid": uid,"_token": $('meta[name="csrf-token"]').attr('content'),"filters": {"carat_from":  $('#size_from').val(),"carat_to": $('#size_to').val(), "shapes": $('#shape').val(), "gemstones": $('#gemstone_types').val()}} ),
		    processData: false,
		    success: function( data, textStatus, jQxhr ){
			    console.log(data.products);
				//ata = $.parseJSON(data.products);
				
				$('.stone-container').empty();
				$.each(data.products, function(i, stone) {
					
					if(stone.images[0] && stone.images[0].link) {
						var img_url = stone.images[0].link;
					}else{
						var img_url = 'https://assets.jewelety.com/Gfnq0z8jUVukMFA0UZ9pIHKyoKNYbrPNMJSFKLsb.jpg';
					}
					
					console.log(stone);
					$('.stone-container').append(`
    

                        <div class="card ${stone.handle}-card">
					   <button id ="imageZoom">+</button>
						 <div class = "card-img" onclick="itemDetail('${stone.id}','${img_url}','${stone.title}','${stone.dimensions}','${stone.carat_weight}','${stone.price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}')" data-id="${stone.id}"  data-title="${stone.title}" data-dimensions=${stone.dimensions}" data-uid="${stone.uid}" data-caratWeight="${stone.carat_weight}" data-price="${stone.price}">
					       <img src = " ${img_url}" />
					     </div>
					
					     <div class = "card-desc">
					      <div class = "card-name">
					      <span id = "stone-name"> ${stone.title} </span>
					       </div>
					
						<div class = "card-dimensions">
							<span id="stone-dimensions"> Dimensions: ${stone.dimensions} </span>
					     </div>
					
							<div class = "card-carat-weight">
							<span id="stone-carat-weight"> Carat Weight: ${stone.carat_weight} </span>
					     </div>
					
					     <div class = "card-price">
							<span id="stone-price"> Stone Price: $${stone.price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")} </span>
					     </div>
					
					  </div>     
					  </div>

					  `);
		               
		               
		                //buildPages(data.allProductCount,data.page);
		                /*$(".stone-container .card").slice(36).hide();
		        		$('#pagination').pagination({
		  
		                  // Total number of items present
		                  // in wrapper class
		                  items: data.products_count,
		
		                  // Items allowed on a single page
		                  itemsOnPage: 36, 
		                  onPageClick: function (noofele) {
		                      $(".stone-container .card").hide()
		                          .slice(36*(noofele-1),
		                          36+ 36* (noofele - 1)).show();
		                  }
		        		});*/
		
		
				});	    
		                     
		        $('#loader-gif').fadeOut(200);
		    },
		    error: function( jqXhr, textStatus, errorThrown ){
		        console.log( errorThrown );
		    }
		});     
	}

 
  
  
});

function itemDetail(id,img_url,title,dimensions,carat_weight,price) {
//alert(id+img_url+title+dimensions+carat_weight+price);
  $("#img-modal-description").html('');
   $("#img-modal-background").css("display", "block");
  $("#img-modal-description").html('');
    var stonedetail='';
      stonedetail = `<div class="img-card-popup">
					  
						 <div class="popup-img">
					       <img id="" src="${img_url}">
					     </div>
					
					     <div class="card-desc modal-desc">
					      <div class="card-name">
					      <span id="stone-name"> ${title}</span>
					       </div>
					
						<div class="card-dimensions">
							<span id="stone-dimensions"> Dimensions: ${dimensions} </span>
					     </div>
					
							<div class="card-carat-weight">
							<span id="stone-carat-weight"> Carat Weight: ${carat_weight} </span>
					     </div>
					
					     <div class="card-price">
							<span id="stone-price"> Stone Price: $${price} </span>
					     </div>
					
					  </div> 
               
					  </div>
 <div class="ring-overview-button" onclick="myClosebutton()">
<a href="javascript:void(0)" id="img-closeModal-close" style="font-family:'Avenir';"><button id="closeBtn">Back to Inventory</button>     
                 </a>
<a href="/pages/Ring-Box" style="font-family:'Avenir';">  <button id="ringBtn">Select Stone</button></a>
                      
                	
                
                 
                      </div>`;
    $("#img-modal-description").html(stonedetail);
}

function myClosebutton(){
  let imgModalBg = document.getElementById("img-modal-background");
   imgModalBg.style.display = "none";
}

   
   
  


